import Model from 'src/models/model'

/**
 * @param {import('@quasar/app-webpack').BootFileParams} params
 */
export default async ({ app, router }) => {
  if (process.env.DEV) {
    window.$app = app
    window.$Model = Model
    window.$router = router
  }

  app.config.globalProperties.$app = app
}
